/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { RichTextComponent } from "../rich-text/rich-text";

const ProcessCardsItem = (props) => {
    const item = props?.item;
    const description = item?.description;
    const heading = item?.heading ?? "";
    const stepNumber = item?.stepNumber;

    return (
        <div className='process-cards-item'>
            <div className='process-card-heading'>
                {heading && <h4>{heading}</h4>}
                {stepNumber && <span>{stepNumber}</span>}
            </div>
            {description && <RichTextComponent component={{ richtext: description }} />}
        </div>
    );
};

ProcessCardsItem.displayName = "ProcessCardsItem";
export { ProcessCardsItem };
